<template lang="pug">
.contact-form
  template(v-if="mode === 'personal'")
    .contact-form__state(v-if="state === 'form'")
      .contact-form__head
        h2 個人のお客様のお問合せ
        p
          i.__required
          | が付いている項目は必須項目です。
      .contact-form__grid
        .contact-form__grid-item
          p.__required お問合せの種類をお選びください
          .contact-form__input-list
            label(
              v-for="(item, i) in categoryList"
              :key="`category-${i}`"
            )
              input(type="radio" v-model="attrs.category" name="category" :value="item" @change="validate('category')")
              .__label {{ item }}
        .contact-form__grid-item
          table
            tr
              th.__required お名前
              td
                input.--input-text(v-model="attrs.name" @blur="validate('name')" placeholder="山田 太郎")
                error-message(:message="error('name')")
            tr
              th.__required お名前（ふりがな）
              td
                input.--input-text(v-model="attrs.name_kana" @blur="validate('name_kana')" placeholder="やまだ たろう")
                error-message(:message="error('name_kana')")
            tr
              th.__required 住所（郵便番号）
              td
                input.--input-text.--short(v-model="attrs.zipcode" @blur="validate('zipcode')" placeholder="105-0011")
                button(@click="fetchAddress") 住所を自動入力
                error-message(:message="error('zipcode')")
            tr
              th.__required 住所（都道府県）
              td
                select(v-model="attrs.prefecture" @blur="validate('prefecture')")
                  option(value="") 選択してください
                  option(
                    v-for="(pref, i) in prefectures"
                    :key="`pref-${i}`"
                    :value="pref"
                  ) {{ pref }}
                error-message(:message="error('prefecture')")
            tr
              th.__required 住所（市区町村番地）
              td
                input.--input-text(v-model="attrs.address" @blur="validate('address')")
                error-message(:message="error('address')")
            tr
              th.__required メールアドレス
              td
                input.--input-text(v-model="attrs.email" @blur="validate('email')" placeholder="info@example.com")
                error-message(:message="error('email')")
                p.--note 確認の為再度ご入力ください
                input.--input-text(v-model="attrs.email_confirm" @blur="validate('email_confirm')" placeholder="info@example.com")
                error-message(:message="error('email_confirm')")
            tr
              th お買上げ店舗名
              td
                input.--input-text(v-model="attrs.shop" @blur="validate('shop')")
                error-message(:message="error('shop')")
                p.--note (お買い上げの商品についてのお問合せの場合はご記入ください)
            tr
              th お買上げ商品名
              td
                input.--input-text(v-model="attrs.product" @blur="validate('product')")
                error-message(:message="error('product')")
                p.--note (お買い上げの商品についてのお問合せの場合はご記入ください)
            tr
              th.__required お問合せ内容
              td
            tr
              td(colspan="2")
                textarea.--input-text(v-model="attrs.message" @blur="validate('message')")
                error-message(:message="error('message')")
          .contact-form__buttons
            button.--primary(@click="handleConfirm") 内容を確認する
    .contact-form__state(v-if="state === 'confirm'")
      .contact-form__head
        h2 個人のお客様のお問合せ
        p 内容を確認して送信してください。
      .contact-form__grid.--single
        .contact-form__grid-item
          table.--confirm
            tr
              th お問合せの種類
              td {{ attrs.category }}
            tr
              th お名前
              td {{ attrs.name }} （{{ attrs.name_kana}}）
            tr
              th 住所
              td
                | 〒 {{ attrs.zipcode }}
                | {{ attrs.prefecture }} {{ attrs.address }}
            tr
              th メールアドレス
              td {{ attrs.email }}
            tr
              th お買上げ店舗名
              td {{ attrs.shop }}
            tr
              th お買上げ商品名
              td {{ attrs.product }}
            tr
              th お問合せ内容
              td(v-nl2br="attrs.message")
          .contact-form__buttons
            button.--primary(@click="handleComplete") 送信する
            button(@click="setState('form')") 戻って修正する
    .contact-form__state(v-if="state === 'complete'")
      .contact-form__head
        h2 個人のお客様のお問合せ
        p お問合せありがとうございます。
        p
          a(href="/") トップへ戻る
    .contact-form__state(v-if="state === 'error'")
      .contact-form__head
        h2 送信エラー
        p
          | メッセージの送信中にエラーが発生しました。
          br
          | 時間をおいて再度お試しいただくか、管理者までお問合せください。
  template(v-else-if="mode === 'business'")
    .contact-form__state(v-if="state === 'form'")
      .contact-form__head
        h2 お取引に関するお問合せ
        p
          i.__required
          | が付いている項目は必須項目です。
      .contact-form__grid
        .contact-form__grid-item
          p.__required お問合せの種類をお選びください
          .contact-form__input-list
            label(
              v-for="(item, i) in categoryList"
              :key="`category-${i}`"
            )
              input(type="radio" v-model="attrs.category" name="category" :value="item" @change="validate('category')")
              .__label {{ item }}
        .contact-form__grid-item
          table
            tr
              th 貴社名
              td
                input.--input-text(v-model="attrs.company_name" @blur="validate('company_name')" placeholder="○○○株式会社")
                error-message(:message="error('company_name')")
                p.--note (法人の方はご記入ください)
            tr
              th 貴社ウェブサイトURL
              td
                input.--input-text(v-model="attrs.company_url" @blur="validate('company_url')" placeholder="https://example.com")
                error-message(:message="error('company_url')")
                p.--note (公開されている場合は、ご記入ください)
            tr
              th 部署名
              td
                input.--input-text(v-model="attrs.company_devision" @blur="validate('company_devision')" placeholder="営業部")
                error-message(:message="error('company_devision')")
                p.--note (法人の方はご記入ください)
            tr
              th.__required お名前
              td
                input.--input-text(v-model="attrs.name" @blur="validate('name')" placeholder="山田 太郎")
                error-message(:message="error('name')")
            tr
              th.__required 住所（郵便番号）
              td
                input.--input-text.--short(v-model="attrs.zipcode" @blur="validate('zipcode')" placeholder="105-0011")
                button(@click="fetchAddress") 住所を自動入力
                error-message(:message="error('zipcode')")
            tr
              th.__required 住所（都道府県）
              td
                select(v-model="attrs.prefecture" @blur="validate('prefecture')")
                  option(value="") 選択してください
                  option(
                    v-for="(pref, i) in prefectures"
                    :key="`pref-${i}`"
                    :value="pref"
                  ) {{ pref }}
                error-message(:message="error('prefecture')")
            tr
              th.__required 住所（市区町村番地）
              td
                input.--input-text(v-model="attrs.address" @blur="validate('address')")
                error-message(:message="error('address')")
            tr
              th.__required お電話番号
              td
                input.--input-text(v-model="attrs.phone" @blur="validate('phone')" placeholder="000-0000-0000")
                error-message(:message="error('phone')")
            tr
              th.__required メールアドレス
              td
                input.--input-text(v-model="attrs.email" @blur="validate('email')" placeholder="info@example.com")
                error-message(:message="error('email')")
                p.--note 確認の為再度ご入力ください
                input.--input-text(v-model="attrs.email_confirm" @blur="validate('email_confirm')" placeholder="info@example.com")
                error-message(:message="error('email_confirm')")
            tr
              th.__required お問合せ内容
              td
            tr
              td(colspan="2")
                textarea.--input-text(v-model="attrs.message" @blur="validate('message')")
                error-message(:message="error('message')")
          .contact-form__buttons
            button.--primary(@click="handleConfirm") 内容を確認する
    .contact-form__state(v-if="state === 'confirm'")
      .contact-form__head
        h2 お取引に関するお問合せ
        p 内容を確認して送信してください。
      .contact-form__grid.--single
        .contact-form__grid-item
          table.--confirm
            tr
              th お問合せの種類
              td {{ attrs.category }}
            tr
              th 貴社名
              td {{ attrs.company_name }}
            tr
              th 貴社ウェブサイトURL
              td {{ attrs.company_url }}
            tr
              th 部署名
              td {{ attrs.company_devision }}
            tr
              th お名前
              td {{ attrs.name }} 
            tr
              th 住所
              td
                | 〒 {{ attrs.zipcode }}
                | {{ attrs.prefecture }} {{ attrs.address }}
            tr
              th お電話番号
              td {{ attrs.phone }}
            tr
              th メールアドレス
              td {{ attrs.email }}
            tr
              th お問合せ内容
              td(v-nl2br="attrs.message")
          .contact-form__buttons
            button.--primary(@click="handleComplete") 送信する
            button(@click="setState('form')") 戻って修正する
    .contact-form__state(v-if="state === 'complete'")
      .contact-form__head
        h2 お取引に関するお問合せ
        p お問合せありがとうございます。
        p
          a(href="/") トップへ戻る
    .contact-form__state(v-if="state === 'error'")
      .contact-form__head
        h2 送信エラー
        p
          | メッセージの送信中にエラーが発生しました。
          br
          | 時間をおいて再度お試しいただくか、管理者までお問合せください。
</template>

<script>
import fields from '../config/fields.json'
import prefectures from '../config/prefectures.json'

import ErrorMessage from './ErrorMessage'
import Validator from 'validator'
import axios from 'axios'
import jsonp from 'axios-jsonp'
import filters from '../lib/filters'

const _escape = (str) => {
  const i = document.createElement('i')
  i.appendChild(document.createTextNode(str))
  return i.innerHTML
}

export default {
  components: {
    ErrorMessage
  },

  directives: {
    nl2br(el, o) {
      const body = _escape(o.value).split('\n').join('<br>')
      el.innerHTML = body
    }
  },

  props: {
    mode: {
      type: String,
      default: ''
    }
  },

  data () {
    const attrs = {
      mode: this.mode
    }
    fields[this.mode].forEach((item) => {
      attrs[item.name] = item.defaultValue || ''
    })

    return {
      state: 'form',
      fields: fields[this.mode],
      attrs,
      errors: [],
      prefectures
    }
  },

  computed: {
    categoryList() {
      const field = this.fields.find((f) => {
        return f.name === 'category'
      })
      if (field && field.items) {
        return field.items
      }
      return [1,2,3]
    }
  },

  watch: {
  },

  created () {
    // get token
    axios.get('./api/index.php/token')
      .then((r) => {
        this.attrs.token = r.data.token
      })
  },

  methods: {
    validate (name) {
      const field = this.fields.find((f) => {
        return f.name === name
      })
      let value = this.attrs[name]
      if (!field) return

      // init error
      this.setError(name, null)
      // if required
      if (!value) {
        if (field.required) {
          this.setError(name, `${field.label}は必須項目です`)
        }
        return
      }
      // map filters
      if (field.filters) {
        field.filters.forEach((f) => {
          value = filters[f](value)
          this.attrs[name] = value
        })
      }
      // map rules
      if (field.rules) {
        Object.keys(field.rules).forEach((key) => {
          const keys = key.split(':')
          const message = field.rules[key]
          switch (keys[0]) {
            case 'length':
              const length = Array.from(value).length
              const arg = parseInt(keys[1], 10)
              if (length > arg) {
                this.setError(name, message)
              }
              break
            case 'email':
              if (!Validator.isEmail(value)) {
                this.setError(name, message)
              }
              break
            case 'url':
              if (!Validator.isURL(value)) {
                this.setError(name, message)
              }
              break
            case 'equals':
              const target = this.attrs[keys[1]]
              if (target !== value) {
                this.setError(name, message)
              }
              break
            case 'pattern':
              const pattern = new RegExp(keys[1])
              if (!pattern.test(value)) {
                this.setError(name, message)
              }
              break
            default: break
          }
        })
      }
    },

    validateAll () {
      let valid = true
      Object.keys(this.attrs).forEach(name => {
        this.validate(name)
      })
      // has error ?
      this.errors.forEach((error, i) => {
        if (error.message) {
          valid = false
        }
      })
      return valid
    },

    setError (name, message) {
      const i = this.errors.findIndex(e => e.name === name)
      const error = { name, message }
      if (i >= 0) {
        this.errors.splice(i, 1, error)
      } else {
        this.errors.push(error)
      }
    },

    error (name) {
      const error = this.errors.find(e => e.name === name)
      return error ? error.message : null
    },

    fetchAddress () {
      axios.get('https://api.zipaddress.net', {
        adapter: jsonp,
        params: {
          zipcode: this.attrs.zipcode
        }
      })
      .then((r) => {
        if (r.data.pref) {
          Object.assign(this.attrs, {
            prefecture: r.data.pref,
            address: r.data.address
          })
        } else {
          alert('該当する住所が見つかりませんでした')
        }
      })
    },

    setState (state) {
      this.state = state
    },

    handleConfirm () {
      if (this.validateAll()) {
        this.state = 'confirm'
      }
    },

    handleComplete (e) {
      e.target.disabled = true
      axios.post('./api/index.php/contact', this.attrs)
        .then((r) => {
          this.setState('complete')
        })
        .catch((e) => {
          this.setState('error')
        })
    }
  }
}
</script>

<style lang="less" scoped>
.contact-form {
  width: 960px;
  margin: 0 auto;
  padding: 80px 0 50px;

  p {
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }

    &.--note {
      font-size: 12/16rem;
      color: gray;
    }
  }

  input, textarea {
    &.--input-text {
      border: 1px solid #999;
      background-color: white;
      font-size: 1em;
      line-height: 2;
      padding: 0 .5em;
      width: 100%;
      box-sizing: border-box;

      &.--short {
        width: 50%;
      }
    }
  }

  select {
    font-size: 15/16rem;
  }

  textarea {
    height: 10rem;
  }

  button {
    font-size: 13/16rem;
    border: 1px solid #ccc;
    background-color: rgba(255, 255, 255, .9);
    color: #222;
    line-height: 2;
    margin: 0 .5em;
  }

  .contact-form__head {
    margin: 0 0 1rem 0;
    h2 {
      font-size: 22/16rem;
      margin: 1em 0;
    }
    p {
      font-size: 1rem;
      margin: 1em 0;
    }
  }

  .contact-form__grid {
    display: flex;

    > * {
      flex: 0 0 auto;
      box-sizing: border-box;
      padding: .5rem 0;

      &:nth-child(odd) {
        flex-basis: 33%;
        border-right: 1px solid #9aa;
        padding-right: .5rem;
      }

      &:nth-child(even) {
        flex-basis: 66%;
        padding-left: .5rem;
      }
    }

    &.--single {
      justify-content: center;

      > * {
        flex-basis: 66%;
        border: none;
      }
    }
  }

  .__required {
    &::after {
      content: "*";
      color: red;
      font-style: normal;
      font-size: 1rem;
      margin: 0 .2em;
    }
  }

  .contact-form__input-list {
    font-size: 15/16rem;
    > label {
      display: flex;
      margin: .5em 0;
      align-items: center;

      > input {
        margin-right: 1em;
      }
    }
  }

  .contact-form__buttons {
    display: flex;
    justify-content: center;
    margin-top: 2rem;

    > button {
      font-size: 1rem;
      padding: 0 1rem;
      border: none;

      &.--primary {
        background-color: #93002A;
        color: #F0EADF;
      }
    }
  }

  table {
    width: 100%;

    th, td {
      color: black;
      font-size: 15/16rem;
      line-height: 2;
      font-weight: normal;
      vertical-align: top;
      padding: .5rem 0;

      &:first-child {
        width: 12rem;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .contact-form {
    width: auto;
    padding-left: 1rem;
    padding-right: 1rem;

    .contact-form__grid {
      display: block;

      > * {
        padding: 0;

        &:nth-child(even) {
          padding: 0;
        }

        &:nth-child(odd) {
          border: none;
          padding: 0;
        }
      }
    }

    table {
      th, td {
        display: block;
        &:first-child {
          width: auto;
        }
      }

      &.--confirm {
        td {
          padding-left: 1rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContactForm.vue